import { getProvider, getWeb3 } from ".";
import config from "../../config/config";

import MafiaKillSkillAbi from "../../abis/MafiaKillSkill.json";

export const getMafiaKillSkillContract = (provider = false) => {
  const web3 = provider ? getProvider() : getWeb3();
  const contractAddress = config.killSkillAddress;
  const MafiaKillSkillContract = new web3.eth.Contract(
    MafiaKillSkillAbi,
    contractAddress
  );
  return MafiaKillSkillContract;
};

export const trainSkill = async (account: string, trainType: number) => {
  const MafiaKillSkillContract = getMafiaKillSkillContract(true);
  const result = await MafiaKillSkillContract.methods
    .trainSkill(trainType)
    .send({ from: account });
  return result;
};

export const getNextTrainTime = async (account: string) => {
  const MafiaKillSkillContract = getMafiaKillSkillContract();
  const nextTrainTime: number = await MafiaKillSkillContract.methods
    .nextTrainTime(account)
    .call({
      from: account,
    });
  return Number(nextTrainTime);
};
